<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template #activator="{ attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        @click="startConfirmingPassword"
      >
        <slot />
      </v-btn>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Passwort bestätigen</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          Um fortzufahren müssen Sie Ihr Passwort eingeben.
          <v-text-field
            v-model="form.password"
            label="Password"
            outlined
            :class="{ 'is-invalid': form.errors.password }"
            class="form-control"
            name="password"
            :error="form.errors.password"
            :error-messages="form.errors.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn
            :loading="form.processing"
            color="primary"
            type="submit"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
   components: {
      //
   },

   props: {

   },

   data () {
      return {
         showPassword: false,
         dialog: false,

         form: this.$inertia.form({
            password: '',
            error: '',
         })
      }
   },

   methods: {
      startConfirmingPassword () {
         this.form.error = ''

         axios.get(this.route('password.confirmation')).then(response => {
            if (response.data.confirmed) {
               this.$emit('confirmed')
            } else {
               this.dialog = true
               this.form.password = ''
            }
         })
      },
      cancel () {
         this.dialog = false
      },
      save () {
         this.form.processing = true

         axios
            .post(this.route('password.confirm'), {
               password: this.form.password,
            })
            .then((response) => {
               this.dialog = false
               this.form.password = ''
               this.form.error = ''
               this.form.processing = false

               this.$nextTick(() => this.$emit('confirmed'))
            })
            .catch((error) => {
               this.form.processing = false
               this.form.error = error.response.data.errors.password[0]
            })
      },
   },
}
</script>
